import { useEffect } from "react";

const BLOCK = new Set(["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", " ", "Tab", "Backspace", "PageUp", "PageDown", "Home", "End"]);
const mods = (e) => (e.altKey ? 1 : 0) | (e.ctrlKey ? 2 : 0) | (e.metaKey ? 4 : 0) | (e.shiftKey ? 8 : 0);

export function useStreamInput(canvasRef, send, active) {
  useEffect(() => {
    const c = canvasRef.current;
    if (!active || !c) return;
    const pos = (e) => {
      const r = c.getBoundingClientRect();
      const s = Math.min(r.width / c.width, r.height / c.height);
      const w = c.width * s, h = c.height * s;
      const ox = r.left + (r.width - w) / 2, oy = r.top + (r.height - h) / 2;
      return { x: Math.max(0, Math.min(1, (e.clientX - ox) / w)), y: Math.max(0, Math.min(1, (e.clientY - oy) / h)) };
    };
    let lastMove = 0;
    const onMove = (e) => {
      const now = performance.now();
      if (now - lastMove < 16) return;
      lastMove = now;
      send({ t: "m", a: "move", ...pos(e), bs: e.buttons ? 1 : 0 });
    };
    const onDown = (e) => { c.focus(); send({ t: "m", a: "down", b: e.button, ...pos(e) }); };
    const onUp = (e) => send({ t: "m", a: "up", b: e.button, ...pos(e) });
    const onWheel = (e) => { e.preventDefault(); send({ t: "m", a: "wheel", dx: e.deltaX, dy: e.deltaY, ...pos(e) }); };
    const onCtx = (e) => e.preventDefault();
    const touches = (e) => [...e.touches].map((t) => ({ id: t.identifier, ...pos(t) }));
    const onTouch = (a) => (e) => { e.preventDefault(); send({ t: "touch", a, p: touches(e) }); };
    const tStart = onTouch("start"), tMove = onTouch("move"), tEnd = onTouch("end");
    const onKey = (a) => (e) => {
      if (e.target.closest?.("[data-play-ui]")) return;
      if (BLOCK.has(e.key) || e.ctrlKey === false) e.preventDefault();
      if (e.repeat && a === "down") return;
      send({ t: "k", a, key: e.key, code: e.code, mod: mods(e) });
    };
    const kDown = onKey("down"), kUp = onKey("up");
    c.addEventListener("mousemove", onMove);
    c.addEventListener("mousedown", onDown);
    window.addEventListener("mouseup", onUp);
    c.addEventListener("wheel", onWheel, { passive: false });
    c.addEventListener("contextmenu", onCtx);
    c.addEventListener("touchstart", tStart, { passive: false });
    c.addEventListener("touchmove", tMove, { passive: false });
    c.addEventListener("touchend", tEnd, { passive: false });
    window.addEventListener("keydown", kDown);
    window.addEventListener("keyup", kUp);
    return () => {
      c.removeEventListener("mousemove", onMove);
      c.removeEventListener("mousedown", onDown);
      window.removeEventListener("mouseup", onUp);
      c.removeEventListener("wheel", onWheel);
      c.removeEventListener("contextmenu", onCtx);
      c.removeEventListener("touchstart", tStart);
      c.removeEventListener("touchmove", tMove);
      c.removeEventListener("touchend", tEnd);
      window.removeEventListener("keydown", kDown);
      window.removeEventListener("keyup", kUp);
    };
  }, [canvasRef, send, active]);
}
